"use strict";
import { useContext } from "react";
import { ShellContext } from "../context";
export function useRootModule() {
  const { rootModule } = useContext(ShellContext);
  return rootModule;
}
